<template>
	<div class="popup-game-menu">
		<div class="bg" v-hammer:tap="close"></div>
		<div class="content">
			<div class="title">{{ 'paused' | lang }}</div>
			<div class="link" v-hammer:tap="quit">{{ 'back_to_home' | lang }}</div>
			<div class="link" v-hammer:tap="restart_game">{{ 'restart_game' | lang }}</div>
			<div class="separator">----------------------</div>
			<div class="link" v-hammer:tap="settings">{{ 'settings' | lang }}</div>
			<div class="separator">----------------------</div>
			<div class="link" v-hammer:tap="close">{{ 'resume_game' | lang }}</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
	name: 'popup-game-menu',
	computed: {
		...mapGetters([ 'lang', 'game', 'user' ])
	},
	methods: {
		quit() {
			this.$router.push({ name: 'home' })
			this.close()
		},
		restart_game() {
			this.$store.dispatch('restart_game')
			this.close()
		},
		settings() {
			this.$store.dispatch('add_popup', { type: 'settings' })
		},
		close() {
			this.$emit('close')
		}
	}
}
</script>

<style lang="stylus" scoped>
@import '../../../assets/css/variables'


.popup-game-menu
	absolute 0
	flex center center
	.bg
		absolute 0
	.content
		max-width 340px
		margin 0 auto
		flex center center column
		transform translateY(-48px)
		text-align center
		color #fff
		.title
			margin 0 0 80px 0
			font-size 8rem
		
		.separator
			width 100%
			margin 16px 0
			
		.link
			display inline-block
			height 48px
			padding 0 24px
			margin 4px 0
			flex center center
			color #fff
			font-size 4rem
			&:hover
				opacity 0.5
		
				
</style>